// extracted by mini-css-extract-plugin
export default {"hr":"Hr__hr___obBbT"};